import {
  ActivePicklistData,
  CancelReportCountdownPayload,
  CommandModeAudioPayload,
  CommandModeKeyPayload,
  CrossTabNotification,
  CrossWindowDataRefetch,
  DeepLink,
  DictationMessage,
  Dre,
  FocusWindow,
  InputReportEventData,
  InsertSectionHeader,
  Payload,
  RecorderVoiceCommandProps,
  ReporterShortcut,
  ReportFacadeBusPayload,
  UpdateSectionHeaders,
  UserSettingsPatchPayload,
  WebHidNotification,
  WorklistItemPatchPayload,
} from '../constants/crossTabEvents';
import { NameSpaces } from '../constants/namespaces';
import { getSharedChannel } from './createCrossTabSubscription';
import { emitter } from './emitter';

export async function sendCrossTabEvent(
  namespace: NameSpaces.CANCEL_REPORT_COUNTDOWN,
  payload: CancelReportCountdownPayload
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.FOCUS_WINDOW,
  payload: FocusWindow
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.DICTATION,
  payload: DictationMessage
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.REPORTER_SHORTCUT,
  payload: ReporterShortcut
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.INPUTREPORT_EVENT,
  payload: InputReportEventData
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.REPORT_FACADE,
  payload: ReportFacadeBusPayload
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.WORKLIST_ITEM_PATCH,
  payload: WorklistItemPatchPayload
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.USER_SETTINGS_PATCH,
  payload: UserSettingsPatchPayload
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.COMMAND_MODE_AUDIO,
  payload: CommandModeAudioPayload
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.COMMAND_MODE_KEY,
  payload: CommandModeKeyPayload
): Promise<void>;
export function sendCrossTabEvent<R>(
  namespace: NameSpaces.WEBHID_NOTIFICATION,
  payload: WebHidNotification<R>
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.INSERT_SECTION_HEADER,
  payload: InsertSectionHeader
): Promise<void>;
export async function sendCrossTabEvent<R>(
  namespace: NameSpaces.DEEP_LINK,
  payload: {
    type: 'INSERT' | 'HANDLE_IMAGE' | 'HANDLE_STUDY';
    payload: DeepLink<R>;
  }
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.UPDATE_SECTION_HEADERS,
  payload: UpdateSectionHeaders
): Promise<void>;
export async function sendCrossTabEvent(
  namespace: NameSpaces.CROSS_WINDOW_DATA_REFETCH,
  payload: CrossWindowDataRefetch
): Promise<void>;
export async function sendCrossTabEvent<R>(
  namespace: NameSpaces.RECORDER_VOICE_COMMAND,
  payload: RecorderVoiceCommandProps<R>
): Promise<void>;
export async function sendCrossTabEvent<R>(
  namespace: NameSpaces.CROSS_TAB_NOTIFICATION,
  payload: CrossTabNotification<R>
): Promise<void>;
export async function sendCrossTabEvent<R>(
  namespace: NameSpaces.ACTIVE_PICKLIST_DATA,
  payload: ActivePicklistData<R>
): Promise<void>;
export async function sendCrossTabEvent<R>(
  namespace: NameSpaces.DRE,
  payload: Dre<R>
): Promise<void>;
export function sendCrossTabEvent(
  namespace: NameSpaces.CROSS_WINDOW_MIRROR_LAYOUT,
  payload: boolean
): Promise<void>;
export async function sendCrossTabEvent<R>(
  namespace: NameSpaces,
  payload: Payload<R>
): Promise<void> {
  if (!namespace) return;

  const bc = getSharedChannel();

  emitter.emit(namespace, payload);

  await bc.postMessage({
    namespace,
    payload,
  });
}
